import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {Stock, StockHistory, StockHistoryCollection} from "@app/core/interfaces";
import {TabStates} from "@app/features/product/product-detail/product-detail";
import {BaseComponent} from "@app/core/bases";
import {CommonModule} from "@angular/common";
import {StockService, UtilityService} from "@app/core/services";
import {takeUntil} from "rxjs";
import {ScrollPanel} from "primeng/scrollpanel";
import {PaginatorModule} from "primeng/paginator";

@Component({
  selector: 'app-product-detail-historiques-stock',
    imports: [CommonModule, ScrollPanel, PaginatorModule],
  templateUrl: './product-detail-historiques-stock.html'
})
export class ProductDetailHistoriquesStock extends BaseComponent implements OnChanges {
    @Input() stock!: Stock;
    @Input() historiques!: StockHistory[]

    @Input() tabStates!: TabStates[];
    @Output() tabStatesChange: EventEmitter<TabStates[]> = new EventEmitter<TabStates[]>();

    @Input() tabIndex!: number;



    rows: number = 10;
    totalRecords: number = 0;

    isLoadingData: boolean = true;

    constructor(
        private stockService: StockService,
        public  utilityService: UtilityService
    ) {
        super();
    }

    ngOnChanges(changes: SimpleChanges): void {
        // if (changes['tabStates']) {
        //     const tab: TabStates = this.tabStates.find(state => state.index === this.tabIndex) as TabStates
        //     if (tab.active && !tab.loaded) {
        //         this.getStockHistoriques();
        //     }
        // }
    }

    getStockHistoriques(): void {
        this.apiCall$?.unsubscribe();
        this.apiCall$ = this.stockService.getStockHistoriqueCollection({stock_id: this.stock.id, page: 1, size: this.rows})
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (collection: StockHistoryCollection) => {
                    this.historiques = collection.results;
                    this.totalRecords = collection.total;
                    this.isLoadingData = false;
                    const tab: TabStates = this.tabStates.find(state => state.index === this.tabIndex) as TabStates
                    tab.loaded = true;
                    this.tabStatesChange.emit(this.tabStates);
                },
                error: () => {
                    this.isLoadingData = false;
                }
            });
    }

    onPageChange(event: any): void {
        const page = event.page + 1;
        const size = event.rows;
        this.apiCall$?.unsubscribe();
        this.apiCall$ = this.stockService.getStockHistoriqueCollection({stock_id: this.stock.id, page: page, size: size})
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (collection: StockHistoryCollection) => {
                    this.historiques = collection.results;
                    this.totalRecords = collection.total;
                }
            });
    }
}
